import { createAction } from 'redux-actions';
import {
    SET_RESULTVALUE
} from '../constants/actionTypes';


export const setResultValue = createAction(SET_RESULTVALUE)